import {ReviewsTranslationsType} from '../../../provider/locale/translation/type';

import {REVIEW_PRESENCE_CHANNEL_PREFIX} from './review-realtime-presence-const';
import {
    ReviewPresenceActivityOptionsType,
    ReviewPresenceBlockedActionEnum,
    ReviewPresenceEventEnum,
    ReviewRealtimeUpdateChangesType,
} from './review-realtime-presence-type';

type BuildPresencePublicationPayloadOptionsType = {
    options: ReviewPresenceActivityOptionsType & {
        event: ReviewPresenceEventEnum.Lock | ReviewPresenceEventEnum.Unlock | ReviewPresenceEventEnum.Heartbeat;
    };
    sessionId: string;
    userId: number;
};

type BuildPresenceUpdatePayloadOptionsType = {
    reviewId: number;
    brandId: number;
    sessionId: string;
    userId: number;
    changes: ReviewRealtimeUpdateChangesType;
};

export function buildPresencePublicationPayload(
    payloadOptions: BuildPresencePublicationPayloadOptionsType
): Record<string, unknown> {
    const {options, sessionId, userId} = payloadOptions;

    return {
        review_id: options.reviewId,
        brand_id: options.brandId,
        user_id: userId,
        session_id: sessionId,
        action: options.action,
        event: options.event,
        timestamp: Date.now(),
    };
}

export function buildPresenceUpdatePayload(
    payloadOptions: BuildPresenceUpdatePayloadOptionsType
): Record<string, unknown> {
    const {reviewId, brandId, sessionId, userId, changes} = payloadOptions;

    return {
        review_id: reviewId,
        brand_id: brandId,
        user_id: userId,
        session_id: sessionId,
        event: ReviewPresenceEventEnum.Update,
        timestamp: Date.now(),
        changes,
    };
}

export function getBrandPresenceChannelName(brandId: number): string {
    return `${REVIEW_PRESENCE_CHANNEL_PREFIX}:${brandId}`;
}

export function isBrandPresenceChannel(channel: string): boolean {
    return channel.startsWith(`${REVIEW_PRESENCE_CHANNEL_PREFIX}:`);
}

const presenceBlockedLocaleKeyByAction: Record<ReviewPresenceBlockedActionEnum, keyof ReviewsTranslationsType> = {
    [ReviewPresenceBlockedActionEnum.Status]: 'REVIEWS__PRESENCE__BLOCKED__STATUS',
    [ReviewPresenceBlockedActionEnum.Reply]: 'REVIEWS__PRESENCE__BLOCKED__REPLY',
    [ReviewPresenceBlockedActionEnum.Abuse]: 'REVIEWS__PRESENCE__BLOCKED__ABUSE',
    [ReviewPresenceBlockedActionEnum.EditReply]: 'REVIEWS__PRESENCE__BLOCKED__EDIT_REPLY',
    [ReviewPresenceBlockedActionEnum.DeleteReply]: 'REVIEWS__PRESENCE__BLOCKED__DELETE_REPLY',
    [ReviewPresenceBlockedActionEnum.ResponsibleUser]: 'REVIEWS__PRESENCE__BLOCKED__RESPONSIBLE_USER',
    [ReviewPresenceBlockedActionEnum.RemoveResponsible]: 'REVIEWS__PRESENCE__BLOCKED__REMOVE_RESPONSIBLE',
    [ReviewPresenceBlockedActionEnum.BulkSelect]: 'REVIEWS__PRESENCE__BLOCKED__BULK_SELECT',
};

export function getPresenceBlockedTooltipLocaleKey(
    blockedAction: ReviewPresenceBlockedActionEnum
): keyof ReviewsTranslationsType {
    return presenceBlockedLocaleKeyByAction[blockedAction];
}
